class Panel {
	constructor(node) {
		this.node = node;
		this.openedClass = 'panels__panel--opened';
		this.opened = this.node.classList.contains(this.openedClass);
		this.title = this.node.querySelector('.panels__title');
		this.content = this.node.querySelector('.panels__content');

		if (this.title) {
			this.title.insertAdjacentHTML('afterbegin', `<i class="panels__toggle"></i>`);
			this.title.addEventListener('click', () => this.toggle());
		}

		// Check if the URL contains an anchor and open the panel if it matches
        const anchor = window.location.hash.substring(1);
        if (anchor && this.node.id === anchor && !this.opened) {
            this.open();
        }
	}

	open() {
		this.node.classList.add(this.openedClass);

		this.content.style.display = 'block';
		this.content.style.position = 'absolute';
		let height = this.content.offsetHeight;
		this.content.style.position = '';
		this.content.style.height = '0px';
		this.content.style.overflow = 'hidden';

		let transitionend = (e) => {
			this.content.removeAttribute('style');
			this.opened = true;
			this.content.removeEventListener('transitionend', transitionend);
		}

		this.content.addEventListener('transitionend', transitionend);

		this.content.style.transitionProperty = 'height, opacity';
		this.content.style.transitionDuration = '300ms';
		this.content.style.transitionTimingFunction = 'cubic-bezier(0.68, -0.55, 0.265, 1.55), linear';

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.content.style.height = `${height}px`;
				this.content.style.opacity = 1;
			})
		});
		this.slickFix();
	}

	close() {
		this.node.classList.remove(this.openedClass);
		this.content.style.display = 'block';
		this.content.style.overflow = 'hidden';
		this.content.style.height = `${this.content.offsetHeight}px`;
		this.content.style.transitionProperty = 'height, opacity';
		this.content.style.transitionDuration = '300ms';
		this.content.style.transitionTimingFunction = 'cubic-bezier(0.68, -0.55, 0.265, 1.55), linear';

		let transitionend = (e) => {
			this.content.removeAttribute('style');
			this.opened = false;
			this.content.removeEventListener('transitionend', transitionend);
		}

		this.content.addEventListener('transitionend', transitionend);

		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				this.content.style.height = '0';
				this.content.style.opacity = 0;
			})
		});
	}

	toggle() {
		return this.opened ? this.close() : this.open();
	}

	slickFix() {
		if (window.gfi_sliders) {
			window.gfi_sliders.forEach(slider => {
				slider.slick('setPosition');
				setTimeout(() => {
					slider.slick('setPosition');
				}, 150);
			});
		}
	}
}

class Panels {
	constructor(node) {
		this.node = node;
		this.node.classList.add('panels--interactive');
		this.panels = Array.from(this.node.querySelectorAll('.panels__panel')).map(node => new Panel(node));
	}
}

Panels.instances = Array.from(document.querySelectorAll('.panels')).map(p => new Panels(p));

export default Panels;
